import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import {
  getCompleteDeals,
  getInfluencerMatchCount,
  getCompleteDealsCount
} from '../../../store/selectors/deals';
import {
  getRatings,
  getAverageRatings,
  getRatingsCount
} from '../../../store/selectors/ratings';
import {
  getActiveCampaigns,
  getCampaigns
} from '../../../store/selectors/campaigns';
import { withFirestore } from 'react-redux-firebase';
import {
  text__primary,
  text__primary_dark,
  white,
  deepPurple,
  grey,
  grey_dark,
  text__secondary
} from '../../../style';
import { CompanyInterestedFromDashboard } from '../../../store/actions/dealActions';
import {
  getDealsByCampaignId,
  getDealList
} from '../../../store/selectors/deals';
import {
  showAlreadyMatchedNotification,
  showNoActiveCampaignsNotification
} from '../../../store/actions/notificationsActions';

const styles = theme => ({
  root: {
    width: '100%',
    padding: '30px',
    marginBottom: '30px'
  },
  layout: {
    width: '100%',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(960)]: {
      // width: 'calc(100% - 215px)',
      boxSizing: 'border-box'
    },
    [theme.breakpoints.down(960)]: {
      width: '100%',
      boxSizing: 'border-box'
    }
  },
  profilePicture: {
    maxWidth: '150px',
    background: white,
    minWidth: 120,
    minHeight: 120,
    '& > img': {
      width: '100%'
    }
  },
  completedDealContainer: {
    background: 'white',
    height: '75px',
    width: '100%',
    marginBottom: '4px'
  },
  dealsContainer: {
    width: '500px'
  },
  profileStatsContainer: {
    textAlign: 'center',
    padding: '10px 30px',
    backgroundColor: 'white',
    borderRadius: 5,
    display: 'flex'
  },
  audienceHeader: {
    color: '#233a54',
    marginBottom: '20px'
  },
  audienceHeaderContainer: {
    display: 'flex'
  },
  demoItem: {
    marginBottom: '10px'
  },
  audienceContainer: {
    background: 'white'
  },
  audienceColumnContainer: {
    width: '250px',
    display: 'inline-block',
    float: 'left'
  },
  interestItem: {
    background: 'white',
    width: 220,
    borderRadius: '15px',
    padding: '30px 10px',
    '& > *': {
      height: '100%'
    }
  },
  headerCell: {
    fontWeight: 'bold'
  },
  icon: {
    width: '100px',
    height: '100px'
  },
  completedDealContainer: {
    background: 'white',
    height: '75px',
    width: '100%',
    marginBottom: '4px'
  },
  dealsContainer: {
    width: '500px'
  },
  camapignLink: {
    '&:hover': {
      textDecoration: 'underline'
    },
    pointer: 'cursor'
  },
  subTitle: {
    marginBottom: 20
  },
  youtubeIcon: {
    color: white
  },
  youtubeVideoUpload: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '30px',
    height: '0',
    overflow: 'hidden',
    '& iframe': {}
  },
  iframeContainer: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  },
  icon: {
    width: '25px',
    height: '25px'
  },
  rating: {
    marginTop: '-4px',
    marginRight: 10
  },
  matchButton: {
    color: 'white',
    float: 'right'
  },
  interest: {
    marginRight: '13px',
    borderRadius: '10px',
    background: 'white',
    padding: '7px'
  },
  interestContainer: {
    marginLeft: '9px',
    marginTop: '15px'
  },
  circleImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: '200px',
    height: '200px'
  },
  link: {
    color: 'black !important',
    textDecoration: 'none !important'
  },
  matchButton: {
    color: 'white',
    float: 'right'
  }
});

const mapStateToProps = (state, ownProps) => {
  return {
    profile: state.firebase.profile,
    auth: state.firebase.auth,
    campaigns: getCampaigns(state),
    activeCampaigns: getActiveCampaigns(state),
    deals: ownProps.campaign
      ? getDealsByCampaignId(ownProps.campaign.id)(state)
      : getDealList(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    CompanyMatchRequestHandler: (influencerId, companyId, campaignId) =>
      dispatch(
        CompanyInterestedFromDashboard(influencerId, companyId, campaignId)
      ),
    showAlreadyMatchedNotification: () =>
      dispatch(showAlreadyMatchedNotification()),
    showNoActiveCampaignsNotification: () =>
      dispatch(showNoActiveCampaignsNotification())
  };
};

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withStyles(styles),
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/influencer/profile/InfluencerProfile.enhancer.js